module.exports = __webpack_public_path__ + "files/bbd6d882f7bcbcf0daa247073ef363b2.png";